module.exports = __webpack_public_path__ + "static/undraw_message_sent_1030-9b0eb34e112bd44be3b198ee2c8d4ed8.svg";